import React, { useEffect } from "react";
import styled from "styled-components";

import Background from "../../../assets/weekend/weekend-bg.png";
import ClockImage from "../../../assets/weekend/weekend-clock.gif";

import GamePageLayout from "../GamePageLayout";

const Image = styled.img`
  position: absolute;
  top: 292px;
  cursor: pointer;
`;

const WeekendPage = ({ setCurrentPage }) => {
  useEffect(() => {
    const timerId = setTimeout(() => setCurrentPage("market-1"), 3000);
    return () => {
      clearTimeout(timerId);
    };
  }, [setCurrentPage]);

  return (
    <GamePageLayout bg={Background} rawContent noButton>
      <Image
        src={ClockImage}
        alt="시계"
        onClick={() => setCurrentPage("market-1")}
      />
    </GamePageLayout>
  );
};

export default WeekendPage;
